const DEBUG = typeof process !== 'undefined' && process.DEBUG;

/**
* Get string.
* 
* @param {string | object | array} value 
* @return {string} 
*/
export const toString = (value) => {
    if(typeof value !== 'undefined' && value !== null){
        if(typeof value === 'object' || Array.isArray(value)){
            return JSON.stringify(value);  
        }
        return value;
    }
    return '';
};

/**
 * Get object key from value.
 * E.g. state name SCANNING frome object literal 
 * const Html5QrcodeScannerState = {UNKNOWN: 1, SCANNING: 1}
 * 
 * @param {any} value 
 * @param {object} object 
 * @param {string} default_key 
 * @return {string}
 */
export const getKeyByValue = (value, object = {}, default_key = null) => {
    for(let key in object){
        if(value === object[key]){ 
            return key; 
        }
    }
    // default
    return default_key ? default_key : null;
};

/**
 * Updates or removes Pair of messages (anyKey, value[anyKey]) in objMessages,
 * e.g. log alert bubbles defined by anyKey
 * 
 * @param {object} objMessages 
 * @param {object} value 
 * @return {null | object} null or new object for state updates
 */
export const updateKey = (objMessages, value) =>{
    if(objMessages && value){
        let [key] = Object.keys(value);
        if(objMessages[key] && !value[key]){
            delete objMessages[key];
        } else {
            objMessages[key] = value[key];
        } 
        return {...objMessages};
    }
    return null;
};

/**
 * Log and format.
 * 
 * @param {string} tag 
 * @param {string} method 
 * @param {string} preValue 
 * @param {string} type log, warn, error, debug, info
 * @param  {...string} elements 
 * @return  {any}
 */
export const log = (tag, method, preValue = '', type = 'error', ...elements) => {
    let output = tag + method + '():';
    if(preValue){
        output += preValue + ':';
    }
    if(!type){
        type = 'error';
    }
    if(DEBUG || // all
      (type === 'error' || type === 'warn' || type === 'info')) { //shown
        // prepare for screen
        let logs = '';
        if(elements){
            for(let i = 0; i < elements.length; i++){
                elements[i] = toString(elements[i]);
                logs += elements[i] + ' ';
            }
        } else {
            elements = [''];
        }
        // eslint-disable-next-line no-console
        console[type](output, ...elements);
      
        switch(type){
            case 'debug': 
            case 'log': type = 'info'; break;
            // shown
            case 'warn': type = 'warning'; break;
            case 'error': type = 'error'; break;
            case 'info': type = 'success'; break;
        }
        if(DEBUG){
            logs = output + ' ' + logs;
        }
        return { [method]: {type: type, message: logs, tag, preValue} };
    }
    return null;
};